import Header from "../../components/ncc/layouts/header";
import Footer from "../../components/ncc/layouts/footer";
import Banner from "../../components/ncc/home/banner";
import "./index.css";
import Cards from "../../components/ncc/home/cards";
import BestSeller from "../../components/ncc/home/bestseller";
import CardSlide from "../../components/ncc/home/cardSlide/card_slide";
import BeMember from "../../components/ncc/home/bemember";
const HomePage = () => {
  const SlideData = [
    {
      id: 1,
      name: "Alin flat Puffy Sandals Black(S0489)",
      price: " 21,000 ",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F1691753863571fb58c7996e29f7c0fb04b546fbe21145?alt=media&token=95985806-da25-4271-bf6e-8957783fc03d",
    },
    {
      id: 2,
      name: "alin heeled sandals（S0494）",
      price: "39,900",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F1691938884304ff9bc4dcb17fe8de153269f68dae3704?alt=media&token=6260fba0-2c4f-40c6-ae00-ab8aca1e132b",
    },
    {
      id: 3,
      name: "Guy Laroche wallet (P0040) Black",
      price: "140,000 ",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F-NcI9Q714_BtECpZ72rZ?alt=media&token=96cb200c-da2a-4f32-add4-5a544f1a40d6",
    },
    {
      id: 4,
      name: "Guy Laroche wallet (P0036) Black",
      price: "118,000",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F-NcILBekCWLY1gDJSxAK?alt=media&token=04aaacf0-bf0f-4e9a-931b-dab9ba2838eb",
    },
    {
      id: 5,
      name: "What's up Waffle Polo Shirt (Black) (R0373)",
      price: "28,800 ",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F-NcMjc6pXEmxl6oHNdTA?alt=media&token=86e51e16-8efc-4076-bea2-318efcc8e548",
    },
    {
      id: 6,
      name: "What's up Waffle Polo Shirt (R0377) (Anchor Grey)",
      price: "28,800 ",
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fncici%2Fitems%2F-NcMkpRt2yoVUngT82E7?alt=media&token=c89cca40-ddb4-4543-9b69-55fe2dcb5804",
    },
  ];
  return (
    <div className="overflow-hidden">
      <Header />
      <Banner />
      <Cards />
      <CardSlide SlideData={SlideData} title={"Best Seller"} />
      <BeMember/>
      <Footer />
    </div>
  );
};

export default HomePage;
